<template>
  <b-container fluid class="table p-6">
    <b-table hover
             show-empty
             responsive
             id="mytable"
             :items="items"
             :fields="fields"
             empty-text="Нет данных в таблице"
             empty-filtered-text="Нет данных по вашему запросу">

      <template slot="inn_kpp" slot-scope="data">
        <p>{{data.item.inn }}/{{ data.item.kpp}} </p>
      </template>
      <template slot="contact_data" slot-scope="data">
        <p class="mb-0">Контактное лицо:{{data.item.company_profile.contact_person }}</p>
        <p class="mb-0">Город:{{data.item.company_profile.city}}</p>
        <p class="mb-0">Email:{{data.item.company_profile.email }}</p>
        <p class="mb-0">Телефон:{{data.item.company_profile.phones }}</p>
      </template>
      <template slot="ctm_id" slot-scope="data">
        <p>{{data.item.company_profile.ctm_id}}</p>
      </template>
      <template slot="ctm_approve" slot-scope="data">
        <i :class="data.item.company_profile.ctm_approved?'fas fa-check':'fas fa-times'"></i>
      </template>
      <template slot="piportal_registered" slot-scope="data">
        <i :class="data.item.company_profile.piportal_registered?'fas fa-check':'fas fa-times'"></i>
      </template>
      <template slot="actions" slot-scope="data">
        <b-button variant="info" class="mr-2" v-b-tooltip.hover title="Infodec" @click="InfodecData(data.item)"><i
          class="fas fa-info-circle"></i></b-button>
        <b-button variant="success" class="mr-2" v-b-tooltip.hover title="ФНС" @click="FNS(data.item)"><i
          class="fas fa-shield-alt"></i></b-button>
        <b-button variant="secondary" class="mr-2" v-b-tooltip.hover title="CRM" @click="CRMData(data.item)"><i
          class="fas fa-donate"></i></b-button>
      </template>
    </b-table>
    <b-modal id="ModInfodec"
             ref="modal"
             title="Данные с Инфодек"
             size="lg">
      <ul v-for="data in FCSData" :key="data">
        <li>{{data}}</li>
      </ul>
    </b-modal>
    <b-modal id="ModFNS"
             ref="modal"
             title="Данные с ФНС"
             size="lg">
      <div v-if="FNSData!==null">
        <div>{{FNSData.ceo}}</div>
        <div><b>Наименование организации -</b> {{FNSData.name}}</div>
        <div><b>ИНН -</b> {{FNSData.inn}}</div>
        <div><b>КПП -</b> {{FNSData.kpp}}</div>
        <div><b>ОГРН -</b> {{FNSData.ogrn}}</div>
        <div><b>Дата регистрации -</b> {{FNSData.registration_date}}</div>
        <div><b>Адрес -</b> {{FNSData.address}}</div>
        <iframe :src="url" class="frame"></iframe>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'lead',
  data () {
    return {
      fields: [
        {
          key: 'company_status',
          label: 'Статус',
          thClass: 'status'
        },
        {
          key: 'name',
          label: 'Организация',
          thClass: 'organization'

        },
        {
          key: 'inn_kpp',
          label: 'ИНН / КПП'
        },
        {
          key: 'contact_data',
          label: 'Контактные данные',
          thClass: 'contact_data'
        },
        {
          key: 'ctm_approve',
          label: 'Клиент СТМ',
          thClass: 'ctm'
        },
        {
          key: 'piportal_registered',
          label: 'Fill-Bill аккаунт',
          thClass: 'piportal'
        },
        {
          key: 'actions',
          label: 'Действия'
        }
      ],
      items: null
    }
  },
  watch: {
    companies () {
      this.items = this.companies.filter(function (elm) {
        return elm.company_profile.ctm_approved === false && elm.company_profile.piportal_registered === false
      })
    }
  },
  computed: {
    ...mapState(
      {
        companies: state => state.companies.companies,
        FCSData: state => state.companies.FCSData,
        FNSData: state => state.companies.FNSData,
        url: state => state.companies.fnsContentUrl
      }
    )
  },
  mounted () {
    this.companiesList()
  },
  methods: {
    FNS (data) {
      this.getFNSData(data).then(
        this.$root.$emit('bv::show::modal', 'ModFNS', event)
      )
    },
    InfodecData (data) {
      this.getInfodecData(data).then(
        this.$root.$emit('bv::show::modal', 'ModInfodec', event)
      )
    },
    CRMData (data) {
      this.sendCRMData(data).then(
        this.$bvModal.msgBoxOk('Данные были успешно отправлены в CRM CTM', {
          title: 'Оповещение',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      )
    },
    ...mapActions('companies',
      [
        'companiesList',
        'getInfodecData',
        'getFNSData',
        'sendCRMData'
      ]
    )
  }
}
</script>

<style scoped>
  .fa-check {
    color: #40b539;
  }

  .fa-times {
    color: #e7161a;
  }

  .frame {
    width: 100%;
    height: 400px;
  }
</style>
